import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { SectionHeader } from './Shared';

const A = 'https://customer-assets.emergentagent.com/job_ace-padel/artifacts/';
const PHOTOS = [
  { src: `${A}93ujk2kh_image%20with%20customers.jpg`, cat: 'Community', alt: 'Players on the blue court' },
  { src: `${A}1ptpwggh_WhatsApp%20Image%202025-11-03%20at%2016.49.48_5b9a56e1.jpg`, cat: 'Courts', alt: 'Ozone Avenue outdoor courts' },
  { src: `${A}mvdi8kf9_WhatsApp%20Image%202025-11-03%20at%2016.05.53_f61beec0.jpg`, cat: 'Tournaments', alt: 'Tournament day' },
  { src: 'https://customer-assets-rejwkqb3.emergentagent.net/job_6382caaa-f387-4f0f-a2f6-6f15c2e16957/artifacts/lbj3mjjb_image.png', cat: 'Courts', alt: 'Kakkanad facility' },
  { src: `${A}cplq6dol_team%20photo.jpg`, cat: 'Community', alt: 'Team photo' },
  { src: `${A}kwbpy2ur_Screenshot%202025-11-03%20161416.png`, cat: 'Tournaments', alt: 'Monthly coaching' },
  { src: `${A}pcjh3kqc_WhatsApp%20Image%202025-11-03%20at%2016.18.10_be2a5efd.jpg`, cat: 'Community', alt: 'Community gathering' },
  { src: `${A}iuitvfvu_Space%20%23%20image.jpg`, cat: 'Courts', alt: 'space# court' },
];
const TABS = ['All', 'Courts', 'Tournaments', 'Community'];

export const NlGallery = () => {
  const [tab, setTab] = useState('All');
  const [active, setActive] = useState(null);
  const shown = PHOTOS.filter((p) => tab === 'All' || p.cat === tab);

  return (
    <section id="gallery" data-testid="nl-gallery" className="nl-section pt-0">
      <div className="nl-container">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionHeader label="Gallery" title="Life at space#" lead="Real courts, real players, real Saturday-night energy." />
          <div className="flex flex-wrap gap-2" data-testid="nl-gallery-tabs">
            {TABS.map((t) => (
              <button key={t} onClick={() => setTab(t)} data-testid={`nl-gallery-tab-${t.toLowerCase()}`} className={`nl-tab ${tab === t ? 'active' : ''}`}>
                {t}
              </button>
            ))}
          </div>
        </div>

        <motion.div layout className="nl-masonry mt-12">
          <AnimatePresence>
            {shown.map((p) => (
              <motion.figure
                key={p.src}
                layout
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.35 }}
                className="nl-masonry-item group"
                onClick={() => setActive(p)}
                data-testid="nl-gallery-item"
              >
                <img src={p.src} alt={p.alt} loading="lazy" />
                <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="nl-label !text-[0.6rem]">{p.cat}</span>
                  <div className="text-sm font-semibold mt-1">{p.alt}</div>
                </figcaption>
              </motion.figure>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            className="nl-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            data-testid="nl-gallery-lightbox"
          >
            <button className="absolute top-6 right-6 w-11 h-11 rounded-full border border-white/20 flex items-center justify-center" aria-label="Close" data-testid="nl-gallery-lightbox-close">
              <X className="w-5 h-5" />
            </button>
            <motion.img src={active.src} alt={active.alt} initial={{ scale: 0.92 }} animate={{ scale: 1 }} />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
